/* Timber custom: continuous scroll for the collection product grid. The
   template still paginates server-side (the numbered links stay in the DOM
   as the no-JS/SEO fallback, hidden once this runs), but as the visitor
   nears the bottom this fetches the next page and appends its product cards,
   so the catalog reads as one page. The next URL is built from
   window.location plus a page param — facets.js pushes the filtered/sorted
   URL into history before it renders, so appended pages always carry the
   active filters. The max page count is read from the pagination digits
   because Dawn's prev/next arrow classes are swapped (a styling quirk) and
   the labels are translated. */
(function () {
  var container = document.getElementById('ProductGridContainer');
  var sentinel = document.getElementById('CollectionLoadMore');
  if (!container || !sentinel) return;
  var spinner = sentinel.querySelector('.loading__spinner');
  var busy = false;

  function readState() {
    var grid = document.getElementById('product-grid');
    if (!grid) return null;
    var maxPage = 1;
    container.querySelectorAll('.pagination__item').forEach(function (item) {
      var n = parseInt(item.textContent, 10);
      if (n > maxPage) maxPage = n;
    });
    var url = new URL(window.location.href);
    var loaded = parseInt(grid.dataset.loadedPage, 10) || parseInt(url.searchParams.get('page'), 10) || 1;
    return { grid: grid, maxPage: maxPage, loaded: loaded, url: url };
  }

  function hidePagination() {
    var wrapper = container.querySelector('.pagination-wrapper');
    if (wrapper) wrapper.hidden = true;
  }

  function nearSentinel() {
    return sentinel.getBoundingClientRect().top - window.innerHeight < 1200;
  }

  function maybeLoad() {
    if (busy) return;
    var state = readState();
    if (!state || state.loaded >= state.maxPage) return;
    busy = true;
    if (spinner) spinner.classList.remove('hidden');
    state.url.searchParams.set('page', state.loaded + 1);
    fetch(state.url.toString())
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var fetched = new DOMParser().parseFromString(text, 'text/html');
        var items = fetched.querySelectorAll('#product-grid > li');
        var grid = document.getElementById('product-grid');
        /* Discard if facets.js replaced the grid while this page was in
           flight — the fresh grid restarts from its own page 1. */
        if (grid && grid === state.grid) {
          items.forEach(function (item) {
            /* Same reveal-animation opt-out facets.js applies to its own
               AJAX-rendered cards — appended mid-page, the slide-in cascade
               would stagger for seconds. */
            item.classList.add('scroll-trigger--cancel');
            item.querySelectorAll('.scroll-trigger').forEach(function (el) {
              el.classList.add('scroll-trigger--cancel');
            });
            grid.appendChild(item);
          });
          grid.dataset.loadedPage = state.loaded + 1;
        }
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (spinner) spinner.classList.add('hidden');
        /* The observer won't re-fire while the sentinel stays inside its
           margin, so keep pulling pages until it falls out of range. */
        if (nearSentinel()) maybeLoad();
      });
  }

  hidePagination();

  new IntersectionObserver(
    function (entries) {
      if (entries[0].isIntersecting) maybeLoad();
    },
    { rootMargin: '1200px 0px' }
  ).observe(sentinel);

  /* facets.js swaps the container's innerHTML on every filter/sort change —
     re-hide the fresh pagination and top the grid back up if needed. */
  new MutationObserver(function () {
    hidePagination();
    if (nearSentinel()) maybeLoad();
  }).observe(container, { childList: true });
})();
